import { Link } from 'react-router-dom';
import { getAllTopics } from '@/utils/course';

export default function TopicGrid() {
  const topics = getAllTopics();

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {topics.map((topic) => (
        <Link
          key={topic.id}
          to={`/topics/${topic.id}`}
          className="group relative flex flex-col rounded-lg overflow-hidden border border-background-200 bg-primary-950 cursor-pointer hover:-translate-y-1 transition-all duration-300"
        >
          <div className="relative w-full aspect-[16/10] overflow-hidden">
            <img
              src={topic.cover}
              alt={topic.title}
              title={`${topic.title} · 秘密教学专题`}
              className="w-full h-full object-cover object-top opacity-80 transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/40 to-transparent"></div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <div className="flex flex-wrap gap-1.5 mb-2">
              {topic.tags.slice(0, 2).map((tag) => (
                <span
                  key={tag}
                  className="px-2 py-0.5 rounded-md text-[11px] bg-secondary-500 text-background-50 font-medium"
                >
                  {tag}
                </span>
              ))}
            </div>
            <h3 className="font-heading font-bold text-base text-background-50 leading-snug">
              {topic.title}
            </h3>
            <p className="text-xs text-background-100/75 mt-1.5 line-clamp-2">{topic.intro}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}